import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { deleteInvoice } from '../api/invoicesApi';

export default function useDeleteInvoice() {
    return useMutation({
        mutationFn: deleteInvoice,
        onSuccess: () => toast.success('Invoice deleted'),
        onError: (err) => toast.error(err?.message ?? 'Failed to delete invoice'),
    });
}
